import { Component, OnInit } from '@angular/core';
import 'hammerjs';
import { NguCarousel } from '@ngu/carousel';
import {TranslationsService} from '../services/translations.service';
import {PoolService} from '../services/pool.service';
import {BuildingService} from '../services/building.service';
import {Config} from '../config';
import { Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-swiming-pool',
  templateUrl: './swiming-pool.component.html',
  styleUrls: ['./swiming-pool.component.css']
})
export class SwimingPoolComponent implements OnInit {
  public carouselTile: NguCarousel;
  public carouselTile1: NguCarousel;
  words: any;
  lang: any;
  buildings: any;
  pools: any;
  public backendUrl: any = new Config();
  backgroundImages: any;
  index: number;

  constructor(private translationsService: TranslationsService,
              private poolService: PoolService,
              private buildingService: BuildingService,
              private readonly meta: Meta) {
    this.translationsService.langName$.subscribe((res) => {
      this.lang = res;
    });
  }

  ngOnInit() {
    this.index = 0;
    this.lang = localStorage.getItem('lang');
    this.backgroundImages = [];
    this.translationsService.getTranslations().subscribe(resp => {
      if (!resp.error) {
        this.words = resp.data[0];
        this.buildingService.getBuildings().subscribe(respo => {
          if (!respo.error) {
            this.buildings = respo.data;
            this.poolService.getPools().subscribe(response => {
              if (!response.error) {
                this.pools = response.data;
                this.meta.updateTag({name: 'title', content: this.pools[0].title[this.lang]});
                this.meta.updateTag({name: 'og:image', content:  this.backendUrl.backendUrl + 'images/' + this.pools[0].images[0].name});
                for (let i = 0; i < this.pools.length; i++) {
                  this.pools[i].buildingId = this.buildings.filter( obj => {
                    return obj._id === this.pools[i].buildingId;
                  })[0];
                  for (let j = 0; j < this.pools[i].images.length; j++) {
                    if (this.pools[i].images[j].bc) {
                      this.backgroundImages.push(this.pools[i].images[j].name);
                    }
                  }
                }
              }
            });
          }
        });
      }
    });
    this.carouselTile = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    }

    this.carouselTile1 = {
      grid: {xs: 3, sm: 3, md: 4, lg: 4, all: 0},
      slide: 2,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/swiming-pool/swiming-pool.component.ts